import { type Features, type Listing } from '@ev-tech/search-modules-api';

import { type ListingDataTranslationKey } from './listingDataUtils/types';

type ListingFeatureTranslationKey = Extract<ListingDataTranslationKey, `search.listingData.features.label.${string}`>;

export type PropertyFeature = {
  labelKey: ListingFeatureTranslationKey;
  id: string;
  fieldName: keyof Features;
  condition: (property: Listing) => boolean;
};

const createPropertyFeature = (fieldName: keyof Features, id: string, labelKey: ListingFeatureTranslationKey): PropertyFeature => ({
  fieldName,
  id,
  labelKey,
  condition: (property) => Boolean(property.features?.[fieldName]),
});

export const PROPERTY_FEATURES: PropertyFeature[] = [
  createPropertyFeature('hasAirConditioning', 'ft_airCondition', 'search.listingData.features.label.airCondition'),
  createPropertyFeature('hasBalcony', 'ft_balcony', 'search.listingData.features.label.balcony'),
  createPropertyFeature('hasBasement', 'ft_basementType', 'search.listingData.features.label.basement'),
  createPropertyFeature('hasBuiltInKitchen', 'ft_builtInKitchen', 'search.listingData.features.label.builtInKitchen'),
  createPropertyFeature('hasGarage', 'ft_garage', 'search.listingData.features.label.garage'),
  createPropertyFeature('hasGarden', 'ft_garden', 'search.listingData.features.label.garden'),
  createPropertyFeature('hasPatio', 'ft_patio', 'search.listingData.features.label.patio'),
  createPropertyFeature('hasSeaOrLakeView', 'ft_seaOrLakeView', 'search.listingData.features.label.seaOrLakeView'),
  createPropertyFeature('hasSecuritySystem', 'ft_security', 'search.listingData.features.label.securitySystem'),
  createPropertyFeature('hasSwimmingPool', 'ft_swimmingPool', 'search.listingData.features.label.swimmingPool'),
  createPropertyFeature('hasTennisCourt', 'ft_tennisCourt', 'search.listingData.features.label.tennisCourt'),
  createPropertyFeature('hasTerrace', 'ft_terrace', 'search.listingData.features.label.terrace'),
  createPropertyFeature('hasWaterfront', 'ft_water', 'search.listingData.features.label.waterfront'),
  createPropertyFeature('hasElevator', 'ft_elevator', 'search.listingData.features.label.elevator'),
  createPropertyFeature('isPetsAllowed', 'ft_petsAllowed', 'search.listingData.features.label.petsAllowed'),
  createPropertyFeature('hasFirePlace', 'ft_firePlace', 'search.listingData.features.label.fireplace'),
  createPropertyFeature('hasAttic', 'ft_attic', 'search.listingData.features.label.attic'),
  createPropertyFeature('hasBuiltInWardrobe', 'ft_builtInWardrobe', 'search.listingData.features.label.builtInWardrobe'),
  createPropertyFeature('hasClubhouse', 'ft_clubHouse', 'search.listingData.features.label.clubHouse'),
  createPropertyFeature('hasGolfCourse', 'ft_golfCourse', 'search.listingData.features.label.golfCourse'),
  createPropertyFeature('hasGreenView', 'ft_greenView', 'search.listingData.features.label.greenView'),
  createPropertyFeature('hasGuestToilet', 'ft_guestToilet', 'search.listingData.features.label.guestToilet'),
  createPropertyFeature('hasGym', 'ft_gym', 'search.listingData.features.label.gym'),
  createPropertyFeature('hasJacuzzi', 'ft_jacuzzi', 'search.listingData.features.label.jacuzzi'),
  createPropertyFeature('hasMountainView', 'ft_mountainView', 'search.listingData.features.label.mountainView'),
  createPropertyFeature('hasOpenView', 'ft_openView', 'search.listingData.features.label.openView'),
  createPropertyFeature('hasPlayground', 'ft_playground', 'search.listingData.features.label.playground'),
  createPropertyFeature('hasSauna', 'ft_sauna', 'search.listingData.features.label.sauna'),
  createPropertyFeature('hasSquashCourt', 'ft_squashCourt', 'search.listingData.features.label.squashCourt'),
  createPropertyFeature('isFurnished', 'ft_furnished', 'search.listingData.features.label.furnished'),
  createPropertyFeature('isSeniorOriented', 'ft_seniorOriented', 'search.listingData.features.label.seniorOriented'),
  createPropertyFeature('isWheelchairAccessible', 'ft_wheelChairAccessible', 'search.listingData.features.label.wheelChairAccessible'),
  createPropertyFeature('hasCoveredParking', 'ft_coveredParking', 'search.listingData.features.label.coveredParking'),
  createPropertyFeature('isVastuCompliant', 'ft_vastuCompliant', 'search.listingData.features.label.vastuCompliant'),
  createPropertyFeature('isNetworked', 'ft_networked', 'search.listingData.features.label.networked'),
  createPropertyFeature('hasDiningInBuilding', 'ft_diningInBuilding', 'search.listingData.features.label.diningInBuilding'),
  createPropertyFeature('hasConferenceRoom', 'ft_conferenceRoom', 'search.listingData.features.label.conferenceRoom'),
  createPropertyFeature('hasLobby', 'ft_lobby', 'search.listingData.features.label.lobby'),
];
